<template>
  <div class="create-container">
    <div class="center-container">
      <div class="center-content">
        <!-- 订单号 选择客户 -->
        <div class="order-num-container">
          <div class="order-num">
            <span class="order">
              订单号：{{order_id}}
            </span>
            <el-button class="send-btn" @click="sendCode">发样</el-button>
          </div>
          <div class="order-name">
            <span class="custom-detail">证书抬头：{{custome.cert_company}}</span>
            <span class="custom-detail">客户公司：{{custome.company_name}}</span>
            <span class="custom-detail">客户姓名：{{custome.user_name}}</span>
          </div>
        </div>
        <!-- 搜索 搜索仪器名称  以及仪器所有信息 -->
        <div class="custome-container">
          <div class="custome-left">
            <div class="left-search-container">
              <el-input
                class="search-input"
                placeholder="请输入内容"
                prefix-icon="el-icon-search"
                @keyup.enter.native="searchName"
                v-model="name">
              </el-input>
              <el-button class="search-btn" @click="searchName">搜索</el-button>
            </div>
            <!-- 左侧搜索仪器 -->
            <el-table class="left-table" border  :data="leftData" max-height="600">
              <template slot="empty">
                <img class="empty" src="~assets/icon_none.png" alt="">
                <span class="empty-txt">没有该仪器列表！</span>
              </template>
              <el-table-column fixed prop="device_name" label="仪器名称"></el-table-column>
              <el-table-column  prop="measure" label="范围"></el-table-column>
              <el-table-column  prop="grade" label="等级"></el-table-column>
              <el-table-column label="操作" >
                <template slot-scope="scope">
                  <el-button
                    class="edit-btn"
                    :disabled="scope.row.apply"
                    @click="handleApply(scope.row, scope.$index)"
                    >
                    添加
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="custome-right">
            <el-form :model="device" class="right-form">
              <el-form-item class="detail-list" label="仪器名称:">
                <el-input class="device-name" v-model="device.device_name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item class="detail-list" label="范围:">
                <el-input class="device-name" v-model="device.measure" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item class="detail-list" label="等级:">
                <el-input class="device-name" v-model="device.grade" :disabled="true"></el-input>
              </el-form-item>
              <!-- 选择送检方式 -->
              <el-form-item class="detail-list" label="送检方式:">
                <el-radio-group class="radio-content" @change="radioChange" v-model="device.service_type">
                  <el-radio class="radio-list" :label="0">送检</el-radio>
                  <el-radio class="radio-list" :label="1">上门检</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 实验室 选择 -->
              <el-form-item class="detail-list" label="实验室:">
                <el-select class="device-name"  @change="chooseLab" v-model="device.lab_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in labs"
                  :key="item.lab_id"
                  :label="item.lab_name"
                  :value="item.lab_id">
                </el-option>
              </el-select>
              </el-form-item>
              <!-- 选择送检类型 -->
              <el-form-item class="detail-list" label="送检类型:">
                <el-radio-group class="radio-content" @change="meChange" v-model="device.measure_type">
                  <el-radio class="radio-list" :label="0" >校准</el-radio>
                  <el-radio class="radio-list" :label="1" >检测</el-radio>
                  <el-radio class="radio-list" :label="2" >检定</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item class="detail-list" label="价格:">
                <el-input class="device-name" type="number" v-model="device.mprice"></el-input>
              </el-form-item>
              <el-form-item class="detail-list" label="仪器编号:">
                <el-input class="device-name" v-model="device.asset_code"></el-input>
              </el-form-item>
              <el-form-item class="detail-list" label="生产厂家:">
                <el-input class="device-name" v-model="device.vendor"></el-input>
              </el-form-item>
              <el-form-item class="detail-list" label="备注:">
                <el-input class="device-name" type="textarea"  v-model="device.memo"></el-input>
              </el-form-item>
              <el-form-item class="detail-list">
                <el-button class="save-btn" @click="saveOrderItem">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 下面该订单的仪器的详细列表 -->
        <el-table class="bottom-container" :data="bottomData" border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">该订单没有该仪器列表！</span>
          </template>
          <el-table-column prop="device_name" label="仪器名称"></el-table-column>
          <el-table-column prop="measure" label="范围"></el-table-column>
          <el-table-column prop="grade" label="等级"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="lab_name" label="实验室"></el-table-column>
          <el-table-column prop="asset_code" label="编号"></el-table-column>
          <el-table-column prop="memo" label="备注"></el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row, scope.$index)"
                >
                修改
              </el-button>
              <el-button
                class="delete-btn"
                @click="handleDelete(scope.row, scope.$index)"
                >
                删除
              </el-button>
              <el-button class="copy-btn" @click="handleCopy(scope.row)">复制</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
    <search-custome v-if="newOrderShow" @closeorder="close"></search-custome>
    <!-- 删除的弹框 -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
    <get-img v-if="imgShow" :order ="order_id" @closeimg="closeImg"></get-img>
  </div>
</template>

<script type="text/javascript">
import SearchCustome from 'components/SearchCustome.vue'
import DeleteBox from 'components/DeleteBox.vue'
import GetImg from 'components/GetImg.vue'
export default {
  data () {
    return {
      custome: {},
      order_id: '',
      name: '',
      device: {
      },
      labs: [],
      newOrderShow: false,
      leftData: [],
      bottomData: [],
      deleteIndex: '',
      deleteRow: {}, // 删除的数据
      deleteShow: false, // 删除弹框的显示
      imgShow: false
    }
  },
  mounted() {
    this.order_id =  this.$route.query.order_id
    this.initData()
    this.getAllLab()
  },
  methods: {
    initData() { // 获取订单信息
      let that = this
      that.$api.orderDetail({
        order_id: that.order_id
      }).then(res => {
        if (res.data.data.length > 0) {
          that.bottomData = res.data.data.map((item, index) => {
            item.index = index
            return item
          })
          that.custome = res.data.user
        } else {
          that.$message({
            message: '数据获取错误！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    radioChange(e) { // 送检方式选择
      let device = this.device
      device.service_type = e
    },
    meChange(e) { // 送检类型选择
      let device = this.device
      device.measure_type = e
    },
    searchName() { // 点击搜索
      let that = this;
      if (!that.name) {
        this.$message({
          message: '搜索不能为空',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
        return;
      }
      that.$api.orderDeviceSearch({
        device_name: that.name
      }).then(res => {
        if(res.data.length > 0) {
          that.leftData = res.data
        } else {
          that.leftData = []
          that.$message({
            message: '没有该仪器信息！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    /* chooseCustome() { // 点击创建客户
      this.newOrderShow = true
    }, */
    close(order) { // 监听自定义的
      let that = this
      that.newOrderShow = false
      if (order.order_id) {
        this.order = {...order}
      } else {
        this.$message({
          message: '请选择客户！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    handleApply(row) { // 操作
      console.log(row)
      let that = this;
      that.device = {
        ...row,
        lab_id:'',
        service_type: 0,
        measure_type: 0,
        mprice: '',
        item_id: '',
        asset_code: '',
        memo: '',
        vendor: ''
      }
      that.addOrderDevice()
    },
    addOrderDevice() { // 点击添加调用的后台的元素
      let that = this
      that.$api.orderAddDevice({
        device_cat_id: that.device.device_cat_id,
        lab_id: that.device.lab_id
      }).then(res => {
        if (res.data[0].lab_id) {
          let pd = res.data[0]
          if(!that.device.lab_id){
            that.device.lab_id = pd.lab_id
          }
          that.device.price = pd.price
          that.device.jianding_price = pd.jianding_price
          that.device.jiance_price = pd.jiance_price
          if (that.device.measure_type == 0) {
            that.device.mprice = that.device.price
          }
          if (that.device.measure_type == 1) {
            that.device.mprice = that.device.jiance_price
          }
          if (that.device.measure_type == 2) {
            that.device.mprice = that.device.jianding_price
          }
        } else {
          that.$message({
            message: '该仪器价格获取错误！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    getAllLab() {
      let that = this
      that.$api.getAllLab({
      }).then(res => {
        if (res.data.length > 0) {
          that.labs = res.data
        } else {
          that.labs = []
          that.$message({
            message: '获取实验室错误！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    chooseLab(lab_id) { // 选择实验室
      this.device.lab_id = lab_id
      this.addOrderDevice()
    },
    saveOrderItem() { // 点击右侧的保存
      let that = this
      let device = that.device
      if (!device.lab_id) {
        that.$message({
          message: '请选择实验室！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      if (device.mprice  == 0) {
        that.$message({
          message: '价格不能为0！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      if (!that.order_id) {
        that.$message({
          message: '请选择客户！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.saveOrderItem({
        order_id: that.order_id,
        open_id: that.custome.open_id,
        item_id: device.item_id,
        device_cat_id: device.device_cat_id,
        lab_id: device.lab_id,
        price: device.mprice,
        measure_type: device.measure_type,
        service_type: device.service_type,
        asset_code: device.asset_code,
        memo: device.memo,
        vendor: device.vendor
      }).then(res => {
        if(res.data.msg === true) {
          that.initData()
          that.device = {}
        }
      })
    },
    handleEdit(row) {
      this.device = {...row, mprice: '', jianding_price: '', jiance_price: ''}
      this.device.measure_type = Number(row.measure_type)
      this.device.service_type = Number(row.service_type)
      /* this.$set(this.device, 'mprice', row.price) */
      this.addOrderDevice()
    },
    handleDelete (row, index) { // 删除 已经能够做的 仪器
      let that = this
      that.deleteRow = {...row}
      that.deleteIndex = index
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.deleteShow = false
        that.delete(that.deleteRow.item_id)
        that.deleteRow = {}
      }
    },
    delete (item_id) {
      let that = this
      that.$api.deleteOrderItem({
        item_id: item_id
      }).then(res => {
        if (res.data.msg === true) {
          // let index = that.bottomData.findIndex(item => item.item_id == item_id)
          that.bottomData.splice(that.deleteIndex, 1)
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleCopy(row) {
      this.device= {...row}
      this.device.item_id = ''
      this.device.mprice = row.price
      this.saveOrderItem()
    },
    sendCode () { // 点击发样
      if(this.order_id) {
        this.imgShow = true
      } else {
        this.$message({
          type: 'error',
          message: '没有委托单号！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    closeImg() {
      this.imgShow = false
    }
  },
  watch: {
    'device.measure_type': {
      handler(newName) {
        let that = this
        if (that.device.lab_id) {
          if (newName == 0) {
            that.device.mprice = that.device.price
            that.measure_txt = '校准'
          }
          if (newName == 1) {
            that.device.mprice = that.device.jiance_price
            that.measure_txt = '检测'
          }
          if (newName == 2) {
            that.device.mprice = that.device.jianding_price
            that.measure_txt = '检定'
          }
        }
      }
    }
  },
  components: {
    SearchCustome,
    DeleteBox,
    GetImg
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
</style>
